import { render, staticRenderFns } from "./deadline.vue?vue&type=template&id=936da204"
import script from "./deadline.vue?vue&type=script&lang=ts"
export * from "./deadline.vue?vue&type=script&lang=ts"
import style0 from "./deadline.vue?vue&type=style&index=0&id=936da204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports